import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { ModalDialog } from 'components/ModalDialog';
import { AG_GRID_ICON_SETUP } from 'constantsProject';
import { RequestStatus } from 'features/request/requestSlice';

import cn from 'classnames';

import type { RowData } from '../PriceListUER/types';

import { useWorkScopes } from './useWorkScopes';

import Styles from './PriceListUerWorkScopesModal.module.css';

interface IWorkScopesModal {
    id: RowData['id'];
    onClose: () => void;
}

export const PriceListUerWorkScopesModal = ({ id, onClose }: IWorkScopesModal) => {
    const { columns, rowData, status, title } = useWorkScopes(id);

    const gridOptions = {
        headerHeight: 40,
    };

    return (
        <ModalDialog
            isOpen
            title={title}
            onClose={onClose}
            dockedToWindow="bottom"
            withTitleCloseButton
            isOnClickOutsideDisable
            isLoading={status === RequestStatus.FETCHING}
            withBottomButtons={false}
        >
            <div className={cn('ag-theme-alpine', Styles.priceListUerWorkScopesModal)}>
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columns}
                    animateRows
                    overlayNoRowsTemplate="Нет данных"
                    gridOptions={gridOptions}
                    icons={AG_GRID_ICON_SETUP}
                    suppressCellFocus
                    suppressRowClickSelection
                    suppressRowHoverHighlight
                />
            </div>
        </ModalDialog>
    );
};

PriceListUerWorkScopesModal.displayName = 'PriceListUerWorkScopesModal';
